import React from "react";
import { useSelector } from "react-redux";
import { getCurrentUser } from "../../reducers/currentUser";
import { Helmet } from "react-helmet";
import classNames from "classnames";
import {
  makeStyles,
  useTheme,
  CssBaseline,
  Drawer,
  AppBar,
  Toolbar,
  Typography,
  Divider,
} from "@material-ui/core";
import InternalDrawerList from "./../drawers/Internal.js";
import ClientDrawerList from "./../drawers/Client.js";
import GroupDrawerList from "./../drawers/Group.js";
import CommercialDrawerList from "./../drawers/Commercial.js";
import LogOut from "./../../components/navigation/LogOut";
import { goToPage } from "../../actions/main";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    backgroundColor: "#46494c", //'#02cfa3'
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  logo: {
    overflow: "hidden",
    width: "100%",
    height: "64px",
    background:
      "url(data:image/png;base64,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) center center no-repeat",
  },
  appBar: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
    fontWeight: 300,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    height: "100vh",
    overflow: "auto",
  },
  ribon: {
    transform: "rotate(-45deg)",
    textAlign: "center",
    height: 100,
    lineHeight: "40px",
    color: "#fff",
    fontWeight: "500",
    fontSize: 20,
    margin: "9px 0 0 137px",
    width: 200,
  },
  local: {
    backgroundColor: "#1000ff",
  },
  preprod: {
    backgroundColor: "#e2030d",
    lineHeight: "30px",
    fontSize: 16,
  },
}));

const Page = (props) => {
  const { pageTitle, toolBarTitle, children } = props;
  const theme = useTheme();
  const classes = useStyles({ theme });
  const currentUser = useSelector(getCurrentUser);
  const userRole =
    currentUser !== undefined ? currentUser.get("role") : undefined;
  const isInternal =
    currentUser !== undefined
      ? userRole === "master" || userRole === "superuser"
      : undefined;
  const open = false;
  if (currentUser === undefined) {
    // console.log('no user, back to login');
    goToPage("/login");
    return null;
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>{pageTitle}</title>
        <link rel="canonical" href="https://www.gtech-bo.com/" />
      </Helmet>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar position="absolute" className={classes.appBar}>
          <Toolbar disableGutters={!open} className={classes.toolbar}>
            <Typography
              component="h1"
              variant="h4"
              color="inherit"
              noWrap
              className={classes.title}
            >
               {toolBarTitle}
            </Typography>
            <LogOut />
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(classes.drawerPaper),
          }}
        >
          <div className={classes.logo}>
            {global.env !== "prod" && (
              <div className={classNames(classes.ribon, classes[global.env])}>
                {global.env === "local" && "dev"}
                {global.env === "preprod" && "preprod"}
              </div>
            )}
          </div>
          <Divider />
          {isInternal && <InternalDrawerList currentUser={currentUser} />}
          {!isInternal && userRole === "commercial" && <CommercialDrawerList />}
          {!isInternal && userRole === "client" && <ClientDrawerList />}
          {!isInternal && userRole === "group" && <GroupDrawerList />}
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          {children}
        </main>
      </div>
    </>
  );
};

export default Page;
